import {
    PermissionSchema,
    TGetUserRoleSchema,
    RolePermissionSchema,
} from '@/types/admin-management/admin-roles-types';
import { StateCreator } from 'zustand';

export type TPermissions = {
    permissions: Array<PermissionSchema>;
    roles: Array<TGetUserRoleSchema>;
    rolePermissions: Array<RolePermissionSchema>;
    isUserSuperAdmin: boolean;
};

export type TPermissionsActions = {
    setPermissions: (permissions: Array<PermissionSchema>) => void;
    setRoles: (roles: Array<TGetUserRoleSchema>) => void;
    setRolePermissions: (rolePermissions: Array<RolePermissionSchema>) => void;
    setIsUserSuperAdmin: (isSuperAdmin: boolean) => void;
};

export type PermissionsCombinedState = TPermissions & TPermissionsActions;

// I need to be able to access the permissions list for a user from here
export const permissionsSlice: StateCreator<
    PermissionsCombinedState,
    [],
    [],
    PermissionsCombinedState
> = (set, get) => ({
    permissions: [],
    roles: [],
    rolePermissions: [],
    isUserSuperAdmin: null,
    setPermissions: (permissions) => {
        set({ permissions });
    },
    setRoles: (roles) => {
        set({ roles });
    },
    setRolePermissions: (rolePermissions) => {
        set({ rolePermissions });
    },
    setIsUserSuperAdmin: (isSuperAdmin: boolean) => {
        set({ isUserSuperAdmin: isSuperAdmin });
    },
});
